import React, { useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { Layout, Menu, Drawer , Button, Typography, Space} from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { AppstoreOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';
import MibVendor from './components/MibVendor';
import NicVendor from './components/NicVendor';
import Home from './components/Home';
import ETrade from './components/ETrade';
import WSF from './components/WSF';
import KSalsaEvent from './components/KSalsaEvent';
import NePanKing from './components/NePanKing';
import GuestBook from './components/GuestBook';
import './App.css';


const footerStyle = {
  textAlign: 'center',
  color: '#fff',
  backgroundColor: '#7dbcea',
};

const { Title } = Typography;
const { Header, Content, Footer } = Layout;

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}
const items = [
  getItem('Home', '/',),
  {
    type: 'divider',
  },
  getItem('네이버 판매 왕', '/nepanking',),
  getItem('MIB-Vendor Find', '/mib',),
  getItem('NIC-Vendor Find', '/nic',),
  getItem('E-Trade Hist', '/etrade',),
  getItem('World Salsa Festival', '/wsf',),
  getItem('K-Salsa Event', '/k-salsa',),
  {
    type: 'divider',
  },
  getItem('댓글달기(개발자Blog)', '/blog',),  
];

const App = () => {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const onClick = (e) => {
    console.log('click ', e);
    sessionStorage.setItem('menu', e.key);
    navigate(e.key)
    onClose()
  };

  const onClickTitle = () => {
    navigate('/');
  };

  return (
    <Space
    direction="vertical"
    style={{
      width: '100%',
    }}
    size={[0, 48]}
  >
    <Layout>
      <Header style={{ background: '#fff', padding: '0 12px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', textAlign: 'center', }}>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
            <MenuOutlined onClick={showDrawer} style={{ justifyContent: 'center', fontSize: '20px', padding: '10px 0' }} />
          </div>

          <div onClick={onClickTitle}>
            VoLab.kr
          </div>

          <div>
          
          <Button type="link" >Login</Button>
    
          </div>

        </div>
      </Header>
      <br/>
      <Content style={{ padding: '12px' }}>
        <Drawer
          placement="left"
          closable={false}
          onClose={onClose}
          open={open}
          key="left"
          width={200}
        >

          <Menu
            onClick={onClick}
            style={{
              width: 200,
            }}
            defaultSelectedKeys={sessionStorage.getItem('menu')}
            mode="inline"
            items={items}
          />

        </Drawer>
        <div>
          <Body />
        </div>
      </Content>
      <Footer style={footerStyle}>Copyright 2023. volab.kr, vostock.kr, All Rights Reserved.</Footer>
    </Layout>
    </Space>
  );
};

function Body() {
  return <div>
    <Routes>
      <Route path='/' exact element={<Home></Home>} />
      <Route path='/mib' element={<MibVendor></MibVendor>} />
      <Route path='/nic' element={<NicVendor></NicVendor>} />
      <Route path='/etrade' element={<ETrade></ETrade>} />
      <Route path='/wsf' element={<WSF></WSF>} />
      <Route path='/k-salsa' element={<KSalsaEvent></KSalsaEvent>} />
      <Route path='/nepanking' element={<NePanKing></NePanKing>} />
      <Route path='/blog' element={<GuestBook></GuestBook>} />
    </Routes>
  </div>
}

export default App;